function getApiUrl(): string {
  const envUrl = import.meta.env.VITE_API_URL;
  if (envUrl && typeof envUrl === 'string' && envUrl.trim()) {
    return envUrl.trim().replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return 'https://pickleball-social-api.henlocoetsee.workers.dev';
  }
  return 'http://localhost:8787';
}

export class ApiError extends Error {
  status: number;
  details?: unknown;
  constructor(message: string, status: number, details?: unknown) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.details = details;
  }
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const token = typeof localStorage !== 'undefined' ? localStorage.getItem('pb_token') : null;
  const response = await fetch(`${getApiUrl()}/api${path}`, {
    ...options,
    credentials: 'include',
    headers: {
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      'X-App-Request': 'pickleball-social',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  const body = await response.json().catch(() => ({})) as { error?: string; details?: unknown };
  if (!response.ok) throw new ApiError(body.error ?? `Request failed (${response.status}).`, response.status, body.details);
  return body as T;
}

export const json = (value: unknown): Pick<RequestInit, 'body'> => ({ body: JSON.stringify(value) });

